// 导入合并reducer的依赖
import { combineReducers } from 'redux'

// 导入 登录 模块的 reducer
import A0Layout from './layout'
import A1scene from './A1scene'
import A2line from './A2line'
import A3map from './A3map'
import A5sider from './A5sider'
import A7hot from './A7hot'
import Z1user from './Z1user'
import Z2log from './Z2log'
import B2answer from './B2answer'
import C1type from './C1type'
import D1vision from './D1vision'
// 合并 reducer
const rootReducer = combineReducers({
  A0Layout,
  A1scene,
  A2line,
  A3map,
  A5sider,
  A7hot,
  Z1user,
  Z2log,
  B2answer,
  C1type,
  D1vision
})

// 默认导出
export default rootReducer
